import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CompactPicker } from 'react-color';

export default class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.handleChangeComplete = this.handleChangeComplete.bind(this);
  }

  handleChangeComplete(color) {
    this.props.handleTextColorChange(color, this.props.button);
  }

  render() {
    return (
      <div>
        <CompactPicker
          color={this.props.color}
          onChangeComplete={this.handleChangeComplete}
        />
      </div>
    );
  }
}

ColorPicker.propTypes = {
  handleTextColorChange: PropTypes.func,
  color: PropTypes.string,
  button: PropTypes.string,
};
